import { useRef, useEffect, useState } from 'react';

const useIntersect = (fn: (el: any) => void, threshold = 0.1) => {
  const [element, setElement] = useState([]);
  const watcher = useRef<any>(null);
  const [intersectId, setIntersectId] = useState('');
  const setIntersectElements = (el: any, id = 'id') => {
    setElement(el);
    setIntersectId(id);
  };

  useEffect(() => {
    if (watcher.current) watcher.current.disconnect();

    watcher.current = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry: any) => {
          if (entry.isIntersecting) {
            let elementStyle = entry.target.style;
            elementStyle.opacity = 1;
            elementStyle.transform = 'translateY(0)';
            elementStyle.transition = '0.6s ease transform, 0.6s ease opacity';
            fn(entry);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold,
      },
    );

    element.forEach((ele) => {
      watcher.current.observe(ele);
    });

    return () => {
      watcher.current.disconnect();
    };
  }, [element, intersectId]);

  return { setElement, setIntersectElements };
};

export default useIntersect;
